import React, { use, useEffect, useMemo, useState } from "react"
import PropTypes, { string } from "prop-types"
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Form,
    Modal,
    ModalBody,
    Input,
    FormGroup,
    ModalHeader,
    Button,
    Label,
    FormFeedback,
    Row,
    Col,
} from "reactstrap"
import * as Yup from "yup"

import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Select from "react-select";
import PurchaseTable from "./PurchaseTable"
import CreatePurchaseModel from "./CreatePurchaseModel"
import { dateFormat } from "pages/Common"
import DeleteModel from "common/deleteModel/deleteModel"
import ErrorModel from "common/errorModel/errorModel"
import { exportDataExcel, exportDataExcelPurchaseBills, exportVendorAmountDataExcel } from "components/Common/ExportData"
import PurchasePaymentModel from "./PurchasePaymentModel"
import { GetObjByPaymentModeType } from "_mock/Static_data"
import { get } from "lodash"

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

function PurchaseList() {
    document.title = `Purchase | Raja Rani Couture`
    let { pathname } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()

    const navigate = useNavigate()

    // useStates
    const [modal, setModal] = useState(false)
    const [transactionModal, setTransactionModal] = useState(false)
    const [modalPayment, setModalPayment] = useState(false)
    const [modal1, setModal1] = useState(false)
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [statusValue, setStatusValue] = useState(0)
    const [isEdit, setIsEdit] = useState(false)
    const [editData, setEditData] = useState()
    const [editTransactionData, setEditTransactionData] = useState()
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    // filter data for task-title
    const filterData = textFilter => {
        setSearchText(textFilter == undefined ? '' : textFilter)
    }
    const [userFilter, setUserFilter] = useState(0)
    const [vendorFilter, setVendorFilter] = useState(0)
    const [users, setUsers] = useState([])
    const [vendors, setVendors] = useState([])
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(true)
    const [amountData, setAmountData] = useState({
        TotalAmount: 0,
        TotalPaidAmount: 0,
        TotalUnpaidAmount: 0,
        TotalCashAmount: 0,
        TotalBankAmount: 0,
    })
    const [image, setImage] = useState('')
    const [billNo, setBillNo] = useState('')
    const [imageViewModal, setImageViewModal] = useState(false)
    const [isPurchase, setIsPurchase] = useState(1)
    const [isVendor, setIsVendor] = useState(true)
    const [isPaid, setIsPaid] = useState(false)
    const [transactionData, setTransactionData] = useState([])
    const [vendorsAmountData, setVendorsAmountData] = useState([])
    const [purchaseTransactionIds, setPurchaseTransactionIds] = useState([])

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })

        getApi('Common/vendor/lookup').then(({ data, status }) => {
            if (status === 200) {
                setVendors(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])

    const getPurchaseAmountTransactions = () => {
        postApi(`Purchase/purchase-transactions-amounts`, {
            Id: isPurchase == 3 ? 0 : parseInt(vendorFilter),
            fromDate: (!dateDisble || isPurchase == 3) ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: (!dateDisble || isPurchase == 3) ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
        }).then(({ data, status }) => {
            if (status === 200) {
                setAmountData(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }

    useEffect(() => {
        getPurchaseAmountTransactions()
    }, [vendorFilter, dateFilter, dateDisble, transactionModal, modalPayment, isPurchase])

    const transactionListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi(`Purchase/purchase-transaction-list`, {
            Id: parseInt(vendorFilter),
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
        }).then(({ data, status }) => {
            if (status === 200) {
                setTransactionData(data?.TransactionList)
                setTotalRecords(data?.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // task-title list api
    const PurchaseListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("Purchase/list", {
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
            VendorId: parseInt(vendorFilter),
            UserId: parseInt(userFilter),
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            IsPaid: isPaid,
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data?.PurchaseList)
                setTotalRecords(data?.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // task-title list api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined && isPurchase == 1) {
            PurchaseListApi()
        }
        if (dateFilter[1] != undefined && isPurchase == 2) {
            transactionListApi()
        }
        if (isPurchase == 3) {
            setPurchaseTransactionIds([])
            postApi(`Purchase/vendors-amounts`, {
                displayStart: displayStart,
                pageSize: rowsPerPage,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
            }).then(({ data, status }) => {
                if (status === 200) {
                    setVendorsAmountData(data?.TransactionAmounts)
                    setTotalRecords(data?.TotalRecords)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            }
            )
        }
    }, [isPurchase, searchText, displayStart, rowsPerPage, userFilter, dateFilter, dateDisble, vendorFilter, isPaid, transactionModal, modalPayment])

    // Create task-title handler
    const handleCreatePurchaseClick = () => {
        setEditData('')
        setIsEdit(false)
        toggle()
    }

    // purchase payment
    const handleMakePayment = () => {
        togglePaymnet()
    }

    // popup box handler
    const toggle = () => {
        setModal(!modal)
        // validation.handleReset()
    }

    const togglePaymnet = () => {
        setModalPayment(!modalPayment)
    }

    const handleEdit = (data) => {
        setEditData(data)
        setIsEdit(true)
        toggle()
    }

    const transactionToggle = () => {
        setTransactionModal(!transactionModal)
    }

    const handleEditTransaction = (data) => {
        setEditTransactionData(data)
        transactionToggle()
    }

    const handleDelete = (Id) => {
        setIsLoading(true)
        if (parseInt(Id)) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this purchase bill permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Purchase/delete?ids=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                PurchaseListApi()
                                setPurchaseTransactionIds([])
                                toast.success("Purchase deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Purchase",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }

    }

    const handleDeletePurchaseTransaction = () => {
        if (purchaseTransactionIds.length > 0) {
            if (isPurchase == 1) {
                handleDelete(purchaseTransactionIds.join(','))
            } else {
                handleDeleteTransaction(purchaseTransactionIds.join(','))
            }
        } else {
            toast("Please select Purchase Transaction", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        }

    }

    const handleDeleteTransaction = (Id) => {
        setIsLoading(true)
        if (parseInt(Id)) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this transaction permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Purchase/transaction-delete?ids=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                transactionListApi()
                                setPurchaseTransactionIds([])
                                toast.success("Transaction deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Transaction",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }

    }

    const handleImageView = (Image, BillNo) => {
        setImage(Image)
        setBillNo(BillNo)
        imageViewToggle()
    }

    const imageViewToggle = () => {
        setImageViewModal(!imageViewModal)
    }

    const handleCheckboxChange = (id, isChecked) => {
        setPurchaseTransactionIds((prev) => {
            if (isChecked) {
                if (!prev.includes(id)) {
                    return [...prev, id];
                }
                return prev;
            } else {
                // Remove id
                return prev.filter(id => id !== id);
            }
        });
    };

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                accessor: "Id",
                disableSorting: true,
                width: "4%",
                Cell: ({ row }) => {
                    const { Id } = row.original;
                    return (
                        <div style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                defaultChecked={purchaseTransactionIds.includes(Id)}
                                onChange={(e) => handleCheckboxChange(Id, e.target.checked)}
                            />
                        </div>
                    );
                }
            },
            {
                Header: "Image",
                accessor: "Image",
                width: "5%",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div>
                                <img
                                    onClick={() => handleImageView(row.original.Image, row.original.BillNo)}
                                    style={{
                                        cursor: "pointer",
                                        border: "1px solid #ced4da",
                                        borderRadius: "3px",
                                    }}
                                    width="50px"
                                    height="60px"
                                    src={row.original?.Image}
                                />
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Bill No.",
                accessor: "BillNo",
                width: "8%",
            },
            {
                Header: "Vendor Name",
                accessor: "VendorName",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{ textWrap: "wrap" }}>
                                {row.original.VendorName}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Amount",
                accessor: "TotalAmount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.TotalAmount || 0)}
                        </div>
                    )
                },
            },
            {
                Header: "Payment Mode",
                accessor: "PaymentMode",
                width: "8%",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div>
                                {GetObjByPaymentModeType(row.original.PaymentMode)[0]?.Key}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Date",
                accessor: "Date",
                width: "10%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.Date == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.Date?.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "Created By",
                accessor: "CreatedByName",
                width: "10%"
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "10%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.CreatedOn == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "5%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleEdit(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>

                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDelete(parseInt(row.original.Id))}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )

    const transactioncolumns = useMemo(
        () => [
            {
                accessor: "Id",
                disableSorting: true,
                width: "4%",
                Cell: ({ row }) => {
                    const { Id } = row.original;
                    return (
                        <div style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                defaultChecked={purchaseTransactionIds.includes(Id)}
                                onChange={(e) => handleCheckboxChange(Id, e.target.checked)}
                            />
                        </div>
                    );
                }
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "10%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.CreatedOn == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "Vendor Name",
                accessor: "VendorName",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{ textWrap: "wrap" }}>
                                {row.original.VendorName}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Paid Amt.",
                accessor: "PaidAmount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.PaidAmount || 0)}
                        </div>
                    )
                },
            },
            {
                Header: "Payment Mode",
                accessor: "PaymentMode",
                width: "8%",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div>
                                {GetObjByPaymentModeType(row.original.PaymentMode)[0].Key}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Created By",
                accessor: "CreatedByName",
                width: "10%"
            },
            {
                Header: "Remark",
                accessor: "Remark",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{ textWrap: "wrap" }}>
                                {row.original.Remark == null || row.original.Remark == '' ? "N/A" : row.original.Remark}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "5%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleEditTransaction(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>
                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDeleteTransaction(String(row.original.Id))}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [transactionData]
    )

    const VendorsAmountColumn = useMemo(
        () => [
            {
                Header: "Vendor",
                accessor: "Name",
            },
            {
                Header: "Total Amt.",
                accessor: "TotalAmount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.TotalAmount || 0)}
                        </div>
                    )
                },
            },
            {
                Header: "Total Paid Amt.",
                accessor: "TotalPaidAmount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.TotalPaidAmount || 0)}
                        </div>
                    )
                },
            },
            {
                Header: "Total UnPaid Amt.",
                accessor: "TotalUnpaidAmount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.TotalUnpaidAmount || 0)}
                        </div>
                    )
                },
            },
            {
                Header: "Total Cash Amt.",
                accessor: "TotalCashAmount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.TotalCashAmount || 0)}
                        </div>
                    )
                },
            },
            {
                Header: "Total Bank Amt.",
                accessor: "TotalBankAmount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.TotalBankAmount || 0)}
                        </div>
                    )
                },
            },
        ],
        [vendorsAmountData]
    )

    function writeDataToExcel() {

        if (isPurchase == 3) {
            setIsLoading(true)
            let header = ["Name", "Total Amt.", "Total Paid Amt.", "Total UnPaid Amt.", "Total Cash Amt.", "Total Bank Amt."];
            const mainTitle = "Vendors Total Amount";
            const widthObj = [{
                Key: "A",
                Value: 20,
            },
            {
                Key: "B",
                Value: 15,
            },
            {
                Key: "C",
                Value: 20,
            },
            {
                Key: "D",
                Value: 18,
            },
            {
                Key: "E",
                Value: 25,
            },
            {
                Key: "F",
                Value: 25,
            },
            {
                Key: "G",
                Value: 15,
            },
            {
                Key: "H",
                Value: 15,
            },
            ]
            const extention = "Vendors_Total_Amount.xlsx"
            let excelSheetData = []
            postApi(`Purchase/vendors-amounts`, {
                displayStart: displayStart,
                pageSize: 100000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.TransactionAmounts?.length; index++) {
                        let dataObj = {
                            Name: data?.TransactionAmounts?.[index].Name,
                            TotalAmount: Math.round(data?.TransactionAmounts[index].TotalAmount).toFixed(2),
                            TotalPaidAmount: Math.round(data?.TransactionAmounts[index].TotalPaidAmount).toFixed(2),
                            TotalUnpaidAmount: Math.round(data?.TransactionAmounts[index].TotalUnpaidAmount).toFixed(2),
                            TotalCashAmount: Math.round(data?.TransactionAmounts[index].TotalCashAmount).toFixed(2),
                            TotalBankAmount: Math.round(data?.TransactionAmounts[index].TotalBankAmount).toFixed(2),
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportVendorAmountDataExcel(sheetData, mainTitle, widthObj, extention, amountData)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })
            setIsLoading(false)
        } else {
            setIsLoading(true)
            let header1 = ["Bill No", "Vendor Name", "Amount", "Payment Mode", "Created By", "Date", "Created On"];
            let header2 = ["Created On", "Vendor Name", "Paid Amt.", "Payment Mode", "Created By", "Remark"];
            const mainTitle = "Purchase";
            const widthObj = [{
                Key: "A",
                Value: 18,
            },
            {
                Key: "B",
                Value: 18,
            },
            {
                Key: "C",
                Value: 25,
            },
            {
                Key: "D",
                Value: 18,
            },
            {
                Key: "E",
                Value: 18,
            },
            {
                Key: "F",
                Value: 18,
            },
            {
                Key: "G",
                Value: 18,
            },
            ]

            const extention = "Purchase.xlsx"
            let excelSheetData1 = []
            let excelSheetData2 = []
            if (isPurchase == 1 || isPurchase == 2) {
                var sheetData1 = []
                var sheetData2 = []
                postApi("Purchase/list", {
                    displayStart: displayStart,
                    pageSize: 100000,
                    searchText: searchText.trim(),
                    sortColumn: "",
                    sortOrder: "asc",
                    VendorId: parseInt(vendorFilter),
                    UserId: parseInt(userFilter),
                    fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                        dateFilter[0],
                        "yyyy-MM-dd"
                    ) : new Date().toISOString().slice(0, 10),
                    toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                        dateFilter[1],
                        "yyyy-MM-dd"
                    ) : new Date().toISOString().slice(0, 10),
                }).then(({ data, status }) => {
                    if (status === 200) {
                        // Check if PurchaseList exists and has data
                        if (data?.PurchaseList && Array.isArray(data.PurchaseList) && data.PurchaseList.length > 0) {
                            for (let index = 0; index < data.PurchaseList.length; index++) {
                                let dataObj = {
                                    BillNo: data.PurchaseList[index].BillNo,
                                    VendorName: data.PurchaseList[index].VendorName,
                                    TotalAmount: Math.round(data.PurchaseList[index].TotalAmount).toFixed(2),
                                    PaymentMode: GetObjByPaymentModeType(data.PurchaseList[index]?.PaymentMode)[0]?.Key,
                                    CreatedByName: data.PurchaseList[index].CreatedByName,
                                    Date: data.PurchaseList[index].Date == null
                                        ? "N/A"
                                        : dateFormat(data.PurchaseList[index].Date, "dd-MM-yyyy"),
                                    CreatedOn: data.PurchaseList[index].CreatedOn == null
                                        ? "N/A"
                                        : dateFormat(data.PurchaseList[index].CreatedOn, "dd-MM-yyyy"),
                                }
                                excelSheetData1.push(dataObj);
                            }
                        } else {
                            excelSheetData1.push({
                                BillNo: "No purchases",
                                VendorName: "N/A",
                                TotalAmount: "0.00",
                                PaymentMode: "N/A",
                                CreatedByName: "N/A",
                                Date: "N/A",
                                CreatedOn: "N/A"
                            });
                        }

                        var fields = Object.keys(excelSheetData1[0] || {});
                        sheetData1 = excelSheetData1.map(function (row) {
                            return fields.map(function (fieldName) {
                                return row[fieldName];
                            });
                        });

                        setIsLoading(false);

                        // Only add header if we have data
                        if (excelSheetData1.length > 0) {
                            sheetData1.unshift(header1);
                        }

                        postApi(`Purchase/purchase-transaction-list`, {
                            Id: parseInt(vendorFilter),
                            displayStart: displayStart,
                            pageSize: 100000,
                            searchText: searchText.trim(),
                            sortColumn: "",
                            sortOrder: "asc",
                            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                                dateFilter[0],
                                "yyyy-MM-dd"
                            ) : new Date().toISOString().slice(0, 10),
                            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                                dateFilter[1],
                                "yyyy-MM-dd"
                            ) : new Date().toISOString().slice(0, 10),
                        }).then(({ data, status }) => {
                            if (status === 200) {
                                if (data?.TransactionList && Array.isArray(data?.TransactionList) && data?.TransactionList.length > 0) {
                                    for (let index = 0; index < data?.TransactionList.length; index++) {
                                        let dataObj = {
                                            CreatedOn: data?.TransactionList[index].CreatedOn == null
                                                ? "N/A"
                                                : dateFormat(data?.TransactionList[index].CreatedOn, "dd-MM-yyyy"),
                                            VendorName: data?.TransactionList[index].VendorName,
                                            PaidAmt: Math.round(data?.TransactionList[index].PaidAmount).toFixed(2),
                                            PaymentMode: GetObjByPaymentModeType(data?.TransactionList[index]?.PaymentMode)[0]?.Key,
                                            CreatedByName: data?.TransactionList[index].CreatedByName,
                                            Remark: data?.TransactionList[index].Remark == null || data?.TransactionList[index].Remark == '' ? "N/A" : data?.TransactionList[index].Remark,
                                        }
                                        excelSheetData2.push(dataObj);
                                    }
                                } else {
                                    excelSheetData2.push({
                                        CreatedOn: "No transactions",
                                        VendorName: "N/A",
                                        PaidAmt: "0.00",
                                        PaymentMode: "N/A",
                                        CreatedByName: "N/A",
                                        Remark: "N/A"
                                    });
                                }

                                var fields2 = Object.keys(excelSheetData2[0] || {});
                                sheetData2 = excelSheetData2.map(function (row) {
                                    return fields2.map(function (fieldName) {
                                        return row[fieldName];
                                    });
                                });

                                setIsLoading(false);

                                // Only add header if we have data
                                if (excelSheetData2.length > 0) {
                                    sheetData2.unshift(header2);
                                }
                                exportDataExcelPurchaseBills(sheetData1, sheetData2, mainTitle, widthObj, extention, amountData);
                            } else {
                                toast.error(data, {
                                    style: {
                                        fontSize: "15px",
                                    },
                                });
                            }
                        });

                    } else {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        });
                    }
                    setIsLoading(false);
                    setScreenLoad(false);
                }).catch((error) => {
                    setIsLoading(false);
                    setScreenLoad(false);
                });
                setIsLoading(false)
            } else {

            }


        }
    }

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const handeleCancel = () => {
        transactionToggle()
        validation.handleReset()
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Amount: editTransactionData ? editTransactionData.PaidAmount : '',
        },
        validationSchema: Yup.object({
            Amount: Yup.string().required("The Amount is required"),
        }),
        onSubmit: values => {
            if (values) {
                setformSumitLoading(true)
                putApi("purchase/update-transaction", {
                    Id: editTransactionData?.Id,
                    Amount: parseFloat(values?.Amount) || 0,
                }).then(({ data, status }) => {
                    setformSumitLoading(false)
                    if (status == 400) {
                        setformSumitLoading(false)
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    } else {
                        setformSumitLoading(false)
                        toast.success("Sucessfully updated", {
                            style: {
                                fontSize: "15px",
                            },
                        })
                        transactionListApi()
                        transactionToggle()
                        validation.handleReset()
                    }
                })
            }
        },
    })

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <PurchaseTable
                            columns={isPurchase == 1 ? columns : isPurchase == 2 ? transactioncolumns : VendorsAmountColumn}
                            data={isPurchase == 1 ? tableData : isPurchase == 2 ? transactionData : vendorsAmountData}
                            isGlobalFilter={true}
                            isAddMakingList={true}
                            handleCreatePurchaseClick={handleCreatePurchaseClick}
                            handleMakePayment={handleMakePayment}
                            customPageSize={10}
                            className="custom-header-css"
                            filterData={filterData}
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            setDateFilter={setDateFilter}
                            dateFilter={dateFilter}
                            users={users}
                            vendors={vendors}
                            userFilter={userFilter}
                            setUserFilter={setUserFilter}
                            vendorFilter={vendorFilter}
                            setVendorFilter={setVendorFilter}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            writeDataToExcel={writeDataToExcel}
                            amountData={amountData}
                            isPurchase={isPurchase}
                            setIsPurchase={setIsPurchase}
                            setIsPaid={setIsPaid}
                            isPaid={isPaid}
                            isVendor={isVendor}
                            setIsVendor={setIsVendor}
                            handleDeletePurchaseTransaction={handleDeletePurchaseTransaction}
                            setPurchaseTransactionIds={setPurchaseTransactionIds}
                        />

                        <CreatePurchaseModel
                            modal={modal}
                            toggle={toggle}
                            PurchaseListApi={PurchaseListApi}
                            isEdit={isEdit}
                            editData={editData}
                            vendors={vendors}
                            getPurchaseAmountTransactions={getPurchaseAmountTransactions}
                        />

                        <PurchasePaymentModel
                            modal={modalPayment}
                            toggle={togglePaymnet}
                            PurchaseListApi={PurchaseListApi}
                            vendors={vendors}
                        />

                        <Modal
                            isOpen={imageViewModal}
                            toggle={imageViewToggle}
                            centered={true}
                            size="defualt"
                            style={{ width: isMobile ? "" : "500px" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={imageViewToggle} tag="h5">
                                    Bill No: {billNo}
                                </ModalHeader>
                                <ModalBody>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <img
                                            style={{
                                                cursor: "pointer",
                                                border: "1px solid #ced4da",
                                                borderRadius: "3px",
                                            }}
                                            width="500px"
                                            height="550px"
                                            src={image}
                                        />
                                    </div>
                                </ModalBody>
                            </div>
                        </Modal>

                        <Modal
                            isOpen={transactionModal}
                            toggle={transactionToggle}
                            centered={true}
                            size="defualt"
                            style={{ width: isMobile ? "" : "250px" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={transactionToggle} tag="h5">
                                    Update Transaction
                                </ModalHeader>
                                <ModalBody>
                                    <Form
                                        onSubmit={e => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                        onReset={e => {
                                            e.preventDefault
                                            validation.handleReset()
                                            return false
                                        }}
                                    >
                                        <Row>
                                            <Col md={12}>
                                                <FormGroup className="mb-2">
                                                    <Label htmlFor="validationCustom03" className='required'>
                                                        Paid Amount
                                                    </Label>
                                                    <Input
                                                        name="Amount"
                                                        placeholder="0"
                                                        type="text"
                                                        className="form-control-sm"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        onKeyPress={handleKeyPress}
                                                        value={validation.values.Amount}
                                                        invalid={
                                                            validation.touched.Amount && validation.errors.Amount
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    {validation.touched.Amount && validation.errors.Amount ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.Amount}
                                                        </FormFeedback>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <div className="text-end">
                                            <Button
                                                task-title="secondary"
                                                className="btn btn-primary me-2 btn-sm "
                                                type="button"
                                                onClick={() => handeleCancel()}
                                                color="secondary"
                                            >
                                                Cancel
                                            </Button>
                                            {formSumitLoading ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    task-title="primary"
                                                    className="btn btn-primary btn-sm "
                                                    type="submit"
                                                >
                                                    Submit
                                                </Button>
                                            )}
                                        </div>
                                    </Form>
                                </ModalBody>
                            </div>
                        </Modal >

                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
PurchaseList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default PurchaseList
